import { createApp } from 'vue'
import { VueFire } from "vuefire";
import App from "./App.vue"
// main.js or main.ts
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'; // Optional: for JavaScript components like modal, dropdown, etc.
import 'bootstrap-icons/font/bootstrap-icons.css';
import { createWebHistory, createRouter } from 'vue-router'
import store from './store/store';
import HomeScreen from './routes/Home.vue';
import ProductScreen from './routes/Product.vue'
import ApparelScreen from './routes/Apparel.vue'
import ElectronicsScreen from './routes/Electronics.vue'
import AllProductsScreen from './routes/AllProducts.vue'
import CheckoutScreen from './routes/Checkout.vue'
import CreateAccount from './routes/CreateAccount.vue';
import LoginScreen from './routes/Login.vue'
import SendFeedback from './routes/SendFeedback.vue';
import CreditCard from './routes/CreditCard.vue';
import { firebaseApp } from './firebase';
const routes = [
  { path: '/', component: HomeScreen },
  { path: '/product', component: ProductScreen },
  { path: '/allProducts', component: AllProductsScreen},
  { path: '/apparel', component: ApparelScreen},
  { path: '/electronics', component: ElectronicsScreen},
  { path: '/checkout', component: CheckoutScreen},
  { path: '/create-account', component: CreateAccount},
  { path: '/login', component: LoginScreen},
  { path: '/send-feedback', component: SendFeedback},
  { path: '/credit', component: CreditCard}

]

const router = createRouter({
  history: createWebHistory(),
  routes,
})


const app = createApp(App)
app.use(router)
.use(store)
.use(VueFire, { firebaseApp })
.mount('#app')
